import { render, staticRenderFns } from "./WorkerDelete.vue?vue&type=template&id=32966057&"
import script from "./WorkerDelete.vue?vue&type=script&lang=js&"
export * from "./WorkerDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports